export const API_BASE_URL = import.meta.env.VITE_API_URL || ''

function getAuthToken(): string | null {
  return localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
}

export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const token = getAuthToken()
  const headers = new Headers(init.headers)
  if (!headers.has('Content-Type') && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json')
  }
  if (token) {
    headers.set('Authorization', `Bearer ${token}`)
  }
  return fetch(`${API_BASE_URL}${input}`, { ...init, headers })
}
